import { Component, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';
import { HttpCrudService } from '../../core/services/http-crud.service';
import { HeaderComponent } from '../../common/header/header.component';
import { FooterComponent } from '../../common/footer/footer.component';
import { SidebarComponent } from '../../common/sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, SidebarComponent, RouterOutlet],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  http = inject(HttpCrudService);
  authService = inject(MsalService);

  /**
   * Handles the user logout process.
   *
   * Constructs a payload containing the user's email ID and logout status,
   * sends a POST request to the logout endpoint, and upon success,
   * redirects the user using the `redirectURL` method.
   *
   * @remarks
   * - Uses the first account from the authentication service to retrieve the email ID.
   * - The logout endpoint URL is constructed from environment variables.
   * - The payload is sent as a JSON string in the request body.
   */
  onLogout() {
    this.redirectURL();
  }

  /**
   * Logs the user out and redirects them to the specified post-logout URL.
   *
   * This method calls the `logoutRedirect` function of the authentication service,
   * passing the `postLogoutRedirectUri` from the environment configuration.
   *
   * @remarks
   * Typically used to handle user sign-out and ensure they are redirected to the
   * appropriate landing page after logout.
   */
  redirectURL() {
    this.authService.logoutRedirect({
      // postLogoutRedirectUri: environment.ECOLAB_WEB,
      postLogoutRedirectUri: environment.ROOT,
    });
  }
}
